export function getHighlightedCells(selectedCell, userGrid, filterDigit = null, notes = null) {
  const peers = new Set();
  const sameNumber = new Set();
  const { row, col } = selectedCell;
  const hasSelection = row !== -1 && col !== -1;

  if (hasSelection) {
    for (let i = 0; i < 9; i++) {
      peers.add(`${row}-${i}`);
      peers.add(`${i}-${col}`);
    }

    const boxRow = Math.floor(row / 3) * 3;
    const boxCol = Math.floor(col / 3) * 3;
    for (let r = boxRow; r < boxRow + 3; r++) {
      for (let c = boxCol; c < boxCol + 3; c++) {
        peers.add(`${r}-${c}`);
      }
    }
  }

  let matchValue = null;
  if (filterDigit != null) {
    matchValue = filterDigit;
  } else if (hasSelection) {
    const selectedValue = userGrid[row][col];
    if (selectedValue !== 0) matchValue = selectedValue;
  }

  if (matchValue != null) {
    for (let r = 0; r < 9; r++) {
      for (let c = 0; c < 9; c++) {
        if (userGrid[r][c] === matchValue) {
          sameNumber.add(`${r}-${c}`);
        } else if (userGrid[r][c] === 0 && notes?.[r]?.[c]?.includes(matchValue)) {
          sameNumber.add(`${r}-${c}`);
        }
      }
    }
  }

  return { peers, sameNumber };
}
